import { Fragment, ReactNode } from "react";
import AdminLayout from "../../components/AdminSpace/AdminLayout/AdminLayout";

function AdminSpace() {
    return <Fragment></Fragment>;
}

AdminSpace.getLayout = (page: ReactNode) => (
    <AdminLayout>{page}</AdminLayout>
);

export default AdminSpace;
